<template>
  <div class="warning-handle-wrapper">
    <el-form :model="form" ref="refForm" :rules="rules" label-width="120px" class="form-content">
      <el-row>
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="库区名称" prop="reservoirAreaName">
            <span class="form-value">{{ form.reservoirAreaName || '-' }}</span>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="油库编码" prop="reservoirAreaCode">
            <span class="form-value">{{ form.reservoirAreaCode || '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="OS液位库存量" prop="osQuantity">
            <span class="form-value">{{ form.osQuantity || '-' }}</span>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="账面库存量" prop="nowQuantity">
            <span class="form-value">{{ form.nowQuantity || '-' }}</span>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="库存差异量" prop="difference">
            <span class="form-value" :class="{ 'negative': form.difference && parseFloat(form.difference) < 0 }">
              {{ form.difference || '-' }}
            </span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :sm="12" :md="8">
          <el-form-item label="预警阈值" prop="threshold">
            <span class="form-value">{{ form.threshold || '-' }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :md="12">
          <el-form-item label="预警原因类型" prop="warnType">
            <el-select v-model="form.warnType" placeholder="请选择" class="mobile-select">
              <el-option
                v-for="item in warnTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24">
          <div v-if="form.warnType === '库区设备异常'" style="color: red; margin-bottom: 5px; font-size: 12px;text-align: center;">
            请在处理意见中描述多长时间处理完成
            </div>
          <el-form-item label="处理意见" prop="handlerOpinion">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入处理意见"
              v-model="form.handlerOpinion"
              class="mobile-textarea"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSubmit" class="submit-btn">保 存</el-button>
    </div>
  </div>
</template>
<script>
import * as dd from 'dingtalk-jsapi'
import HttpUtil from '@/common/HttpUtil'
export default {
  name: 'warningHandle',
  components: {},
  data () {
    return {
      formOilTankOptions: [],
      form: {},
      rules: {
        warnType: [{ required: true, message: '请选择预警原因类型' }],
        handlerOpinion: [{ required: true, message: '请填写处理意见' }]
      },
      warnTypes: [],
      statusVal: '已处理'
    }
  },
  computed: {},
  methods: {
    formHandle () {
      try {
        // 尝试解析可能是字符串的预警信息
        this.form = typeof this.$route.query.warnInfo === 'string' ? JSON.parse(this.$route.query.warnInfo) : this.$route.query.warnInfo || {}
      } catch (error) {
        alert('解析预警信息失败: ' + JSON.stringify(error))
        this.form = {}
      }
    },
    getWarnTypes () {
      HttpUtil.post('manage/lifonda/inventoryXnyWarns/types', null).then(
        (res) => {
          if (res && res.data) {
            this.warnTypes = res.data.map((item) => ({
              label: item.name,
              value: item.name
            }))
          }
        }
      ).catch(error => {
        alert('获取预警类型失败: ' + JSON.stringify(error))
      })
    },
    handleSubmit () {
      // 要新增更新接口，通过罐号、OS液位、账面库存和差异量更新预警类型和处理意见
      this.form.status = this.statusVal
      HttpUtil.post('manage/lifonda/inventoryXnyWarns/ddHandle', this.form).then(res => {
        if (res && res.success) {
          alert('处理完成！')
          // 3秒关闭打开的内置浏览器
          setTimeout(() => {
            dd.biz.navigation.close({
              onSuccess: function () {
              },
              onFail: function (err) {
                alert(err)
              }
            })
          }, 3000)
        } else {
          alert('处理预警失败: ' + JSON.stringify(res.msg))
        }
      }).catch(error => {
        alert('处理失败: ' + JSON.stringify(error))
      })
    }
  },
  mounted () {
    // 拿到从登录界面传过来的数据赋值展示
    this.formHandle()
    // 查到后台数据字典中定义的预警类型
    this.getWarnTypes()
  }
}
</script>
<style lang="scss" scoped>
.warning-handle-wrapper {
  width: 100%;
  padding: 10px;
}
.form-content {
  height: 90vh;
  overflow-y: auto;
  padding: 0 5px;
}
// 表单值样式
.form-value {
  color: #606266;
  font-size: 14px;
  padding: 4px 0;
  display: inline-block;
  min-width: 60px;
}
// 差异量为负值时的样式
.form-value.negative {
  color: #f56c6c;
  font-weight: 500;
}
// 对话框底部样式
.dialog-footer {
  display: flex;
  justify-content: center;
}
.submit-btn {
  width: 200px;
  height: 40px;
  font-size: 16px;
}
// 移动端样式优化
.mobile-select {
  width: 100%;
}
.mobile-textarea {
  width: 100%;
}
// 响应式设计
@media screen and (max-width: 768px) {
  .warning-handle-wrapper {
    padding: 5px;
  }
  .form-content {
    label-width: 100px !important;
    height: 90vh;
  }
  .el-form-item__label {
    font-size: 13px;
    padding-right: 5px;
    line-height: 1.2;
  }
  .el-col {
    margin-bottom: 10px;
  }
  .form-value {
    font-size: 13px;
    word-break: break-all;
  }
  .submit-btn {
    width: 150px;
    height: 36px;
    font-size: 14px;
  }
}

@media screen and (max-width: 480px) {
  .form-content {
    label-width: 80px !important;
  }
  .el-form-item__label {
    font-size: 12px;
  }
  .form-value {
    font-size: 12px;
  }
  .submit-btn {
    width: 120px;
    height: 34px;
    font-size: 14px;
  }
}

// 平板设备适配
@media screen and (min-width: 769px) and (max-width: 1024px) {
  .form-content {
    label-width: 110px !important;
  }
  .submit-btn {
    width: 180px;
  }
}
// 滚动条样式
:deep(.el-form__body) {
  overflow-y: auto;
  max-height: inherit;
}
:deep(.el-form__body::-webkit-scrollbar) {
  width: 6px;
}
:deep(.el-form__body::-webkit-scrollbar-track) {
  background: #f1f1f1;
  border-radius: 3px;
}
:deep(.el-form__body::-webkit-scrollbar-thumb) {
  background: #c0c4cc;
  border-radius: 3px;
}
:deep(.el-form__body::-webkit-scrollbar-thumb:hover) {
  background: #909399;
}
</style>
